//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            manual: {}
        };
    },
    created: function created() {
        Event.$on('edit-manual-account', this.editManualAccount);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-manual-account');
    },

    methods: {
        editManualAccount: function editManualAccount(account) {
            var _this = this;

            axios.post('/prototype/accounting/bank-accounts/fetchManual', { id: account.id }).then(function (response) {
                _this.manual = response.data;
                _this.$children[0].showSmallModal = true;
            });
        },
        save: function save() {
            var _this2 = this;

            axios.post('/prototype/accounting/bank-accounts/updateManual', this.manual).then(function () {
                _this2.manual = {};
                _this2.$children[0].showSmallModal = false;
                Event.$emit('refresh-bank-accounts');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/banking/EditManualAccount.vue
// module id = p9HH
// module chunks = 0 1